<template>
  <form>
    <base-card>
        <product-image @setImage="setImage" :image="targetItem.image" class="two" />
        <base-input :label="StringLanguage.productName" v-model="targetItem.name" class="mb_20" />
        <base-textarea :label="`${StringLanguage.ingredients} / ${StringLanguage.description}`" v-model="targetItem.description" rows="4" :class="{ m_0: targetItem.sizes && targetItem.sizes.length > 1 }" />
        <div class="half-cols mt_20" v-if="targetItem.sizes && targetItem.sizes.length == 1">
          <base-input :label="StringLanguage.value" v-model="targetItem.sizes[0].price" class="m_0 pr-7 flex" :money-mask="StringLanguage.currencyConfigs" />
          <base-input :label="StringLanguage.promo" v-model="targetItem.sizes[0].originalPrice" class="m_0 pl-7 flex" :money-mask="StringLanguage.currencyConfigs" />
        </div>
    </base-card>

    <base-card v-if="targetItem.sizes && targetItem.sizes.length > 1">
      <div class="d-flex">
        <div class="flex mr-10">
          <p class="text-title">{{StringLanguage.size}}</p>
        </div>
        <div class="d-flex">
          <div class="label-money mr-10">
            <p class="text-title">{{StringLanguage.value}}</p>
          </div>
          <div class="label-money">
            <p class="text-title">{{StringLanguage.promo}}</p>
          </div>
        </div>
      </div>

      <div v-for="(size) in targetItem.sizes" :key="size._id" >
        <div class="d-flex">
          <div class="flex mr-10">
            <base-input :value="size.name" class="mb_0" title="Para alterar este tamanho, vá até a categoria do produto" disabled />
          </div>
          <div class="d-flex">
            <div class="input-money mr-10">
              <base-input v-model="size.price" class="mb_0" :money-mask="StringLanguage.currencyConfigs" />
            </div>
            <div class="input-money">
              <base-input v-model="size.originalPrice" class="mb_0" :money-mask="StringLanguage.currencyConfigs" />
            </div>
          </div>
        </div>
      </div>
    </base-card>

    <!-- Disponibilidade -->
    <base-availability
      name="do produto"
      :availability="targetItem.availability"
      @updateAvailability="updateAvailability"
    ></base-availability>
    <!-- fim Disponibilidade -->
  </form>
</template>
<script>
import ProductImage from "@/containers/Catalog/ProductImage"
import Builder from "@/plugins/core/schema/components/Builder.js";
import Vue from "vue";
import { Money } from "v-money";
import { getXAPIEnv } from '@/plugins/account'

import BaseCard from '@/components/Card'
import BaseInput from '@/components/Input'
import BaseButton from '@/components/Button'
import BaseTextarea from '@/components/Textarea'

import StringTemplate from 'easyjs/lib/Tools/StringTemplate'
import BaseAvailability from "@/containers/Availability";

export default {
  data() {
    return {
      StringTemplate,
      targetItem: Builder.factory("Flavor"),
      originCategory: {},
      flavors: [],
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },
      deleteMode: {
        main: false
      }
    };
  },
  components: {
    ProductImage,
    BaseCard,
    BaseInput,
    BaseButton,
    BaseTextarea,
    BaseAvailability
  },
  computed: {
    environment() {
      return getXAPIEnv();
    },
  },
  methods: {
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
    setModel(item, parent) {
      this.cleanModel()
      this.originCategory = parent;
      this.targetItem = item || Builder.factory('Flavor');
      this.targetItem.parent_ref = parent
      this.targetItem.parent = parent._id || null
      if(this.targetItem.sizes.length == 0) {
        this.targetItem.addItems(this.originCategory.sizes)
      }

      this.targetItem.sizes.map(size => {
        if (size.originalPrice > size.price) {
          let aux = size.price;
          size.price = size.originalPrice;
          size.originalPrice = aux;
        }
      })
    },
    setImage(fileName){
      this.targetItem.image = fileName
    },
    cleanModel() {
      for (let key of Object.keys(this.deleteMode)) {
        this.deleteMode[key] = false;
      }
    },
    deleteItem() {
      this.targetItem.delete = true
      this.$emit('saveItem', this.targetItem)
    },
    getItem() {
      return this.targetItem
    }
  }
};
</script>
<style scoped>
  .text-title{
    text-transform: uppercase;
    color: #868686;
    font-weight: 900;
    font-size: 10px;
    width: 100%;
  }
  .half-cols {display: flex; justify-content: space-between}
  .pl-7 {padding-left: 7.5px}
  .pr-7 {padding-right: 7.5px}
  .input-money, .label-money {width: 105px}
  .mr-10 {margin-right: 10px}
</style>